import styled from "styled-components";

const ModalOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
`;

const ModalContent = styled.div`
	background: white;
	border-radius: 16px;
	width: 100%;
	max-width: 400px;
	padding: 24px;
`;

const Title = styled.h2`
	font-size: 20px;
	font-weight: 600;
	color: ${(props) => props.theme.colors.text_01};
	margin-bottom: 12px;
`;

const Message = styled.p`
	color: ${(props) => props.theme.colors.text_02};
	margin-bottom: 24px;
	line-height: 1.5;
`;

const ButtonGroup = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
`;

const Button = styled.button<{ variant?: "danger" | "secondary" }>`
	padding: 8px 16px;
	border-radius: 8px;
	font-weight: 500;
	cursor: pointer;
	transition: opacity 0.2s;
	min-width: 80px;

	${(props) =>
		props.variant === "danger"
			? `
    background: #D93025;
    color: white;
    border: none;

    &:hover {
      opacity: 0.9;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `
			: `
    background: ${props.theme.colors.gray_02};
    color: ${props.theme.colors.text_01};
    border: 1px solid ${props.theme.colors.gray_03};

    &:hover {
      background: ${props.theme.colors.gray_03};
    }
  `}
`;

interface Props {
	open: boolean;
	handleClose: () => void;
	approve: () => void;
	message: string;
	loading?: boolean;
}

export const ConfirmationModal: React.FC<Props> = ({
	open,
	handleClose,
	approve,
	message,
	loading = false,
}) => {
	if (!open) return null;

	return (
		<ModalOverlay onClick={handleClose}>
			<ModalContent onClick={(e) => e.stopPropagation()}>
				<Title>Confirmation</Title>
				<Message>{message}</Message>
				<ButtonGroup>
					<Button onClick={handleClose}>Cancel</Button>
					<Button variant='danger' onClick={approve} disabled={loading}>
						{loading ? "Loading..." : "Confirm"}
					</Button>
				</ButtonGroup>
			</ModalContent>
		</ModalOverlay>
	);
};
